import * as ActionTypes from 'state/types'
import * as Selectors from 'state/selectors'
import { fetchCounters } from './counters'
import Routes from 'shared/utils/api/routes'

export const fetchSettingsInboxesOptions = () => ({
  type: ActionTypes.FETCH_SETTINGS_INBOXES_OPTIONS_REQUEST,
  payload: {
    url: Routes.INBOXES_SETTINGS_OPTIONS_ROUTE,
    method: 'get'
  }
})

export const settingsInboxesOnToggle = ({ itemIndex, inboxIndex }) => ({
  type: ActionTypes.SETTINGS_INBOXES_ON_TOGGLE,
  payload: {
    itemIndex,
    inboxIndex
  }
})

export const saveSettingInboxes = () => ({
  type: ActionTypes.SETTINGS_INBOXES_SAVE_PREPARE,
  payload: {
    url: Routes.INBOXES_SETTINGS_SAVE_ROUTE,
    method: 'post'
  },
  meta: {
    finalActionType: ActionTypes.SETTINGS_INBOXES_SAVE_REQUEST,
    selectorsToPayload: [
      {
        selector: Selectors.prepareSettingInboxesToSave,
        deepLevel: ['data'],
        key: 'inboxes'
      }
    ],
    meta: {
      successActions: [
        {
          type: ActionTypes.INBOXES_REQUEST,
          payload: {
            url: Routes.INBOXES_LIST_ROUTE,
            method: 'get'
          }
        },
        fetchCounters()
      ]
    }
  }
})
